import { AxiosError } from 'axios';
import { useQuery } from 'react-query';
import { Axios } from '@utils/api/axios-instance';
import { URL_EXTENSION } from '@utils/constants/app-constants';
import { BaseError } from '@utils/types/shared/base';
import { PlanBoDetailedResponse } from '@utils/types/back-office/update-plan-bo';

/**
 * Hook to fetch a single plan with detailed data (nested price plans, reseller publications, etc.)
 * Uses GET /api/v3/admin/plan/{id}?detailed=true
 */
export const useGetPlanBoDetailed = (id: string | number | undefined) => {
  const fetchPlanDetailed = async () => {
    if (!id) {
      throw new Error('Plan ID is not defined');
    }
    const response = await Axios.get<PlanBoDetailedResponse>(
      `${URL_EXTENSION}/admin/plan/${id}?detailed=true`
    );
    return response.data;
  };

  return useQuery<PlanBoDetailedResponse, AxiosError<BaseError>>(
    ['planBoDetailed', id],
    fetchPlanDetailed,
    {
      enabled: !!id,
      useErrorBoundary: false
    }
  );
};
